import { getSimplifiedLanguageCode, translateFromStorage } from '~/utils/translate'

export const termsUrl =
  getSimplifiedLanguageCode() === 'pt'
    ? 'https://www.doris.mobi/termos-e-condicoes-e-politica-de-privacidade'
    : 'https://www.doris.mobi/en/privacy-policy'

export const emailErrorMessage = () => translateFromStorage('NEWSLETTER_BACKDROP_FORM_EMAIL_ERROR')
